<template>
  <div class="next-draws-view">
    <LuckyNumbersSection
      title="Upcoming Draws"
      description="Stay updated with daily Lucky Numbers draws, all week long. See upcoming draws, track results, and never miss a moment of the action."
      :games="upcomingDrawsStore.draws"
      :isFavorited="isFavorited"
      @bet="handleBet"
      @favorite="handleFavorite"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import type { UpcomingDraw } from '../types/lottery'
import LuckyNumbersSection from '../components/LuckyNumbersSection.vue'
import { useUpcomingDrawsStore } from '../stores/upcomingDraws'

const upcomingDrawsStore = useUpcomingDrawsStore()
const favorites = ref<UpcomingDraw[]>([])

// Load favorites from local storage
const loadFavorites = () => {
  const savedFavorites = localStorage.getItem('favoriteDraws');
  if (savedFavorites) {
    favorites.value = JSON.parse(savedFavorites);
  }
};

// Save favorites to local storage
const saveFavorites = () => {
  localStorage.setItem('favoriteDraws', JSON.stringify(favorites.value));
};

const handleBet = (draw: UpcomingDraw) => {
  // Implement bet logic or emit event as needed
  console.log('Bet clicked for draw:', draw);
}

const handleFavorite = (draw: UpcomingDraw) => {
  if (!draw || typeof draw.id === 'undefined') return;
  const index = favorites.value.findIndex(fav => fav.id === draw.id);
  if (index === -1) {
    favorites.value.push(draw);
  } else {
    favorites.value.splice(index, 1);
  }
  saveFavorites();
}

const isFavorited = (draw: UpcomingDraw) => {
  if (!draw || typeof draw.id === 'undefined') return false;
  return favorites.value.some(fav => fav.id === draw.id);
};


onMounted(async () => {
  loadFavorites();
  if (!upcomingDrawsStore.draws.length) {
    // Fetch all draws without date filter
    upcomingDrawsStore.fetchDraws(1)
  }
})

</script>

<style scoped>
@media screen and (max-width: 768px) {
  .next-draws-view {
    padding: 0 6px;
  }
}
</style>